import { ReactNode } from "react";
import { ZaklynNavbar } from "@/components/marketing/ZaklynNavbar";
import { ZaklynFooter } from "@/components/marketing/ZaklynFooter";

interface PublicLayoutProps {
  children: ReactNode;
}

/**
 * PublicLayout:
 * - Shows global navbar and footer
 * - No auth checks; suitable for public pages (home, services, login)
 * - Adds top padding to prevent content overlap with sticky navbar
 */
export default function PublicLayout({ children }: PublicLayoutProps) {
  return (
    <>
      <ZaklynNavbar />
      <div className="pt-16 md:pt-20">
        {children}
      </div>
      <ZaklynFooter />
    </>
  );
}